"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/UMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_239)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_239`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V1.84561H-6V0ZM-6 3.69123H30V5.53684H-6V3.69123ZM-6 7.38246H30V9.22807H-6V7.38246ZM-6 11.0737H30V12.9193H-6V11.0737ZM-6 14.7719H30V16.6175H-6V14.7719ZM-6 18.4632H30V20.3088H-6V18.4632ZM-6 22.1544H30V24H-6V22.1544Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H12V12.9193H-6V0Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.64559 9.74737L-2.92629 8.84913L-3.23506 9.74737H-4.16138L-3.4105 10.2877L-3.6912 11.186L-2.92629 10.6316L-2.18243 11.186L-2.47015 10.2877L-1.70524 9.74737H-2.64559ZM1.30529 9.74737L1.01757 8.84913L0.722834 9.74737H-0.203482L0.547395 10.2877L0.266694 11.186L1.01757 10.6316L1.77547 11.186L1.49476 10.2877L2.24564 9.74737H1.30529ZM5.2702 9.74737L4.96845 8.84913L4.68775 9.74737H3.74038L4.51231 10.2877L4.21757 11.186L4.96845 10.6316L5.74038 11.186L5.44564 10.2877L6.19652 9.74737H5.2702ZM9.21406 9.74737L8.93336 8.84913L8.63862 9.74737H7.70529L8.46319 10.2877L8.18248 11.186L8.93336 10.6316L9.69126 11.186L9.3895 10.2877L10.1614 9.74737H9.21406ZM1.01757 5.28421L0.722834 6.18246H-0.203482L0.547395 6.73685L0.266694 7.62106L1.01757 7.07369L1.77547 7.62106L1.49476 6.73685L2.24564 6.18246H1.30529L1.01757 5.28421ZM-2.92629 5.28421L-3.23506 6.18246H-4.16138L-3.4105 6.73685L-3.6912 7.62106L-2.92629 7.07369L-2.18243 7.62106L-2.47015 6.73685L-1.70524 6.18246H-2.64559L-2.92629 5.28421ZM4.96845 5.28421L4.68775 6.18246H3.74038L4.51231 6.73685L4.21757 7.62106L4.96845 7.07369L5.74038 7.62106L5.44564 6.73685L6.19652 6.18246H5.2702L4.96845 5.28421ZM8.93336 5.28421L8.63862 6.18246H7.70529L8.46319 6.73685L8.18248 7.62106L8.93336 7.07369L9.69126 7.62106L9.3895 6.73685L10.1614 6.18246H9.21406L8.93336 5.28421ZM-2.92629 1.73334L-3.23506 2.61755H-4.16138L-3.4105 3.17193L-3.6912 4.06316L-2.92629 3.50878L-2.18243 4.06316L-2.47015 3.17193L-1.70524 2.61755H-2.64559L-2.92629 1.73334ZM1.01757 1.73334L0.722834 2.61755H-0.203482L0.547395 3.17193L0.266694 4.06316L1.01757 3.50878L1.77547 4.06316L1.49476 3.17193L2.24564 2.61755H1.30529L1.01757 1.73334ZM4.96845 1.73334L4.68775 2.61755H3.74038L4.51231 3.17193L4.21757 4.06316L4.96845 3.50878L5.74038 4.06316L5.44564 3.17193L6.19652 2.61755H5.2702L4.96845 1.73334ZM8.93336 1.73334L8.63862 2.61755H7.70529L8.46319 3.17193L8.18248 4.06316L8.93336 3.50878L9.69126 4.06316L9.3895 3.17193L10.1614 2.61755H9.21406L8.93336 1.73334Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_239`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as UMFlag };
